import './index.css'
import Button from '../button';
import { handleLoginAttempt } from '../../functions/login';
import { useState,useEffect } from 'react';
function LoginForm(){
  const [checkOutURL,setCheckOutURL] = useState('');
  const [email,setEmail] = useState(null);
  const [productId, setProductId] = useState('price_1RC2TN06lJfTdtb1n2wJqYeb');
  const [error,SetError] = useState("")

  useEffect(() => {
    let url = `${process.env.REACT_APP_BACKEND_URL}/create-checkout-session?email=${email}&productId=${productId}`;
    setCheckOutURL(url);
  }, [email,productId]);


  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    // Perform email validation via an API call or some other method
    const response = await handleLoginAttempt();
    console.log(response);
    if (response.success) {
      // If validation is successful, proceed with form submission
      console.log("successful attempt wahey!!");
      const date = new Date();
      date.setMonth(date.getMonth() + 1); // Add one month to current date
      let toSetDate = date.toUTCString(); // Format it as UTC string for cookie
      document.cookie = `mako_auth=${response.id}; expires=${toSetDate}; path=/; SameSite=None; Secure`;
      window.location.href = "/feed"; // Redirect to the "/input" page
    } else {
      if(response.status===401){
        SetError("Invalid credentials.");
      }
      if(response.status===402){
              const date = new Date();
      date.setMonth(date.getMonth() + 1); // Add one month to current date
        let toSetDate = date.toUTCString(); // Format it as UTC string for cookie
        document.cookie = `mako_auth=${response.id}; expires=${toSetDate}; path=/; SameSite=None; Secure`;
        window.location.href = "/payment"; // Redirect to the "/payment" page
      }
      // If validation fails, display an error message
    }
  };
    return <div className="form-wrapper">
    <div className="form">
    <input id="email-input" type="email" placeholder="Email" autoComplete="off" className="small-text" onInput={(e) => setEmail(e.target.value)}></input>
    <input id="password-input" type="password" placeholder="Password" autoComplete="off" className="small-text"></input>
    <form id='checkout-form' action={checkOutURL} method='POST'>
      <button type='button' className='button small-text' onClick={handleSubmit}>
        Login
      </button>
    </form>
    <div id="error-message" className="small-text">{error}</div>
    <div id="reset-password" className="small-text"><a href="/reset-password">Forgotten your password?</a></div>
    </div>
    </div>
  }

export default LoginForm